






































import { TextType } from 'expangine-runtime';
import { TextRadioOptions } from './TextRadioTypes';
import TypeInputBase from '../TypeInputBase';


export default TypeInputBase<TextType, TextRadioOptions, string>(String).extend({
  name: 'TextRadio',
  data: () => ({
    otherId: Math.random() + '',
  }),
  computed: {
    radioValue: {
      get(): string {
        return this.inItemsOrEmpty ? this.computedValue : this.otherId;
      },
      set(value: string) {
        this.computedValue = value === this.otherId ? '' : value;
      },
    },
    otherValue: {
      get(): string {
        return this.inItemsOrEmpty ? '' : this.computedValue;
      },
      set(value: string) {
        this.computedValue = value;
      },
    },
    items(): string[] {
      return this.settings.options.items;
    },
    inItemsOrEmpty(): boolean {
      return this.inItems || this.computedValue === '';
    },
    inItems(): boolean {
      return this.items.indexOf(this.computedValue) !== -1;
    },
    hasHint(): boolean {
      return !this.hideHint;
    },
    hideHint(): boolean {
      return !this.settings.options.hint;
    },
  },
});
